import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BotsListComponent } from './bots-list/bots-list.component';
import { BotsComponent ,OtpDialog,GuidelinesDialog,TemplateDialog,Iconlibrarydialog,TemplateUpload, EmailOtpDialog} from './bots.component';
import { BootsRoutingModule} from './bots-routing.module';
import { CreateBotComponent } from './create-bot/create-bot.component'
import {MatStepperModule} from '@angular/material/stepper';
import {MatCardModule} from '@angular/material/card';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { NgOtpInputModule } from  'ng-otp-input';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { LaunchBotComponent } from './launch-bot/launch-bot.component';
import {MatDividerModule} from '@angular/material/divider';
import { EditBotComponent } from './edit-bot/edit-bot.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {LaunchBotDialog} from './launch-bot/launch-bot.component'
import { ClipboardModule } from 'ngx-clipboard';
import { BotSubmitDialog} from './edit-bot/edit-bot.component';
import {BotIconSelect} from './edit-bot/edit-bot.component'
// import { TooltipModule } from 'ng2-tooltip-directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {MatRippleModule} from '@angular/material/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LibModule } from '../lib/lib.module';
import {MatSliderModule} from '@angular/material/slider';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CroppieModule } from 'angular-croppie-module';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { LySliderModule } from '@alyle/ui/slider';
import {  UpdateFaqDialog } from './edit-bot/edit-bot.component';

@NgModule({
    declarations: [
        BotsListComponent,
        BotsComponent,
        CreateBotComponent,
        OtpDialog,
        EmailOtpDialog,
        GuidelinesDialog,
        TemplateDialog,
        Iconlibrarydialog,
        LaunchBotComponent,
        EditBotComponent,
        LaunchBotDialog,
        BotSubmitDialog,
        TemplateUpload,
        UpdateFaqDialog,
        BotIconSelect
    ],
    imports: [
        CommonModule,
        BootsRoutingModule,
        MatStepperModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MatIconModule,
        MatInputModule,
        MatSlideToggleModule,
        NgOtpInputModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatSelectModule,
        MatRadioModule,
        MatCheckboxModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        ClipboardModule,
        TooltipModule,
        MatRippleModule,
        NgbModule,
        LibModule,
        MatSliderModule,
        ImageCropperModule,
        CroppieModule,
        LyImageCropperModule,
        LyButtonModule,
        LyIconModule,
        LySliderModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BotsModule { }
